import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SideBar from "../Components/SideBar";

export default function AdminLogout(){

    const navigate = useNavigate();
  const [showModal, setShowModal] = useState(true);

    const handleSubmit = async () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/admin/login");
      };
    
      const handleCloseModal = () => {
        setShowModal(false);
        navigate("/admin/")
      };
    return(
        <div className="admin-logout">
            <SideBar/>
            {showModal && <div className="backdrop" />}
      {showModal && (
        <div className="modal2">
          <div className="modal-content2">
            <h3>Are you sure you want to logout?</h3>
            <div className="modal-buttons">
              <div style={{ marginTop: "1rem" }} className="modal-buttons">
                <button className="cancel-logout" onClick={handleCloseModal}>
                  Cancel
                </button>
                <button
                  style={{ marginLeft: "1rem" }}
                  className="confirm-logout"
                  onClick={handleSubmit}
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
        </div>
    )
}